import React from 'react';
import { Form, Input, Button, Popconfirm, message, InputNumber, Checkbox } from 'antd';
import PropTypes from 'prop-types';
import Fetch from '../../Fetch'

const YearForm = props => {
    const [loading, setLoading] = React.useState({ save: false, delete: false });
    const { getFieldDecorator } = props.form;

    const formSummited = (e) => {
        e.preventDefault();
        props.form.validateFields(async (err, values) => {
            if (!err) {
                try {
                    setLoading({ ...loading, save: true })
                    if (props.edit) {
                        await Fetch.put(`/grade/${props.record.id}`, { ...values, graduate: values.graduate ? 1 : 0 });
                        message.info('Grade berhasil diedit');
                    }
                    else {
                        await Fetch.post('/grade', { ...values, graduate: values.graduate ? 1 : 0 });
                        message.info('Grade berhasil ditambahkan');
                    }
                    props.onSuccess()
                    setLoading({ ...loading, save: false })
                } catch (err) {
                    message.error('Error: ' + err);
                }
            }
        });
    }

    const onConfirm = async () => {
        setLoading({ ...loading, delete: true });
        await Fetch.del(`/grade/${props.record.id}`);
        message.info('Grade berhasil dihapus');
        props.onSuccess();
        setLoading({ ...loading, delete: false });
    }

    return (
        <div>
            <Form layout="horizontal" onSubmit={formSummited}>
                <Form.Item label="Nilai grade">
                    {getFieldDecorator('value', {
                        rules: [{ required: true, message: 'Harus diisi' }],
                        initialValue: props.record ? props.record.value : ''
                    })(
                        <InputNumber placeholder="Masukkan grade" />
                    )}
                </Form.Item>
                <Form.Item label="Nama grade">
                    {getFieldDecorator('name', {
                        rules: [{ required: true, message: 'Harus diisi' }],
                        initialValue: props.record ? props.record.name : ''
                    })(
                        <Input placeholder="Masukkan nama grade" />
                    )}
                </Form.Item>
                <Form.Item label="Lulus?">
                    {getFieldDecorator('graduate', {
                        rules: [{ required: true, message: 'Harus diisi' }],
                        initialValue: props.record ? (props.record.graduate === 0 ? false : true) : false,
                        valuePropName: 'checked',
                    })(
                        <Checkbox>Kelas terakhir</Checkbox>
                    )}
                </Form.Item>
                <Form.Item>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Button
                            loading={loading.save}
                            type="primary"
                            htmlType="submit"
                        >
                            Simpan
                        </Button>
                        {props.edit &&
                            <Popconfirm placement="bottomLeft" title={"Yakin menghapus grade?"} onConfirm={onConfirm} okText="Iya" cancelText="Tidak">
                                <Button loading={loading.delete} type="danger">Hapus</Button>
                            </Popconfirm>
                        }
                    </div>
                </Form.Item>
            </Form>
        </div>
    )
}

YearForm.propTypes = {
    edit: PropTypes.bool.isRequired,
    onSuccess: PropTypes.func,
}

export default Form.create()(YearForm);